import { Link } from '@material-ui/core';
import classNames from 'classnames';
import * as React from 'react';
const emdash = '—';
const fallback = (node) => {
    if (typeof node === 'number')
        return node;
    return (typeof node === 'string' ? node.trim() : node) || emdash;
};
const TwoColRow = ({ label, value, className, styleId, link, lineHeightSmall, smallerWidth }) => (React.createElement("div", { className: classNames('ReadReport__Table__Row', className), id: styleId },
    React.createElement("div", { className: smallerWidth ? "ReadReport__Table__Col__smallerWidth" : "ReadReport__Table__Col" },
        React.createElement("p", { className: lineHeightSmall ? ["Paragraph", "lineHeight"].join(' ') : "Paragraph" }, label)),
    React.createElement("div", { className: smallerWidth ? "ReadReport__Table__Col__smallerWidth" : "ReadReport__Table__Col" }, link ?
        React.createElement(Link, { href: link, target: "_blank", className: "Paragraph" }, label)
        : React.createElement("p", { className: lineHeightSmall ? ["Paragraph", "lineHeight"].join(' ') : "Paragraph" }, fallback(value)))));
export default TwoColRow;
